import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Commitments from "./pages/Commitments";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import CaseStudyEcommerce from "./pages/CaseStudyEcommerce";
import CaseStudyHealthtech from "./pages/CaseStudyHealthtech";
import CaseStudyFintech from "./pages/CaseStudyFintech";
import ServiceSocialMedia from "./pages/ServiceSocialMedia";
import ServiceWebsite from "./pages/ServiceWebsite";
import ServiceDigitalMarketing from "./pages/ServiceDigitalMarketing";
import ServiceAI from "./pages/ServiceAI";
import ServiceMobileApp from "./pages/ServiceMobileApp";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminPostEditor from "./pages/AdminPostEditor";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <Toaster />
    <Sonner />
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/commitments" element={<Commitments />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/case-studies/ecommerce" element={<CaseStudyEcommerce />} />
        <Route path="/case-studies/healthtech" element={<CaseStudyHealthtech />} />
        <Route path="/case-studies/fintech" element={<CaseStudyFintech />} />
        <Route path="/services/social-media" element={<ServiceSocialMedia />} />
        <Route path="/services/website" element={<ServiceWebsite />} />
        <Route path="/services/digital-marketing" element={<ServiceDigitalMarketing />} />
        <Route path="/services/ai" element={<ServiceAI />} />
        <Route path="/services/mobile-app" element={<ServiceMobileApp />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/post/:id" element={<AdminPostEditor />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </QueryClientProvider>
);

export default App;
